import { createSafeContext } from '@/util';

import type { VBaseTrackContextValue } from './type';

const BaseTrackContext = createSafeContext<VBaseTrackContextValue<any>>(
  null,
  'VBaseTrackContext',
);

export default BaseTrackContext;
